import { YouTubeDebugPage } from "@/components/debugging/youtube-debug-pages";

export default function DebugEmbeddedYouTubeStep02Page() {
  return <YouTubeDebugPage stepNumber="02" />;
}
